import * as React from 'react';
import Axios from 'axios';

import {Dialog, DialogContent, TextField, Button, Fab } from "@mui/material";

import ErrorMessage from '../error-message/hoa-error-message';

import './hoa-login.scss';

interface ILoginState {
	newUserPage: boolean;
	dialogOpen: boolean;
	username: string;
	password: string;
	errorMessage: string;
	newEmail: string;
	newPassword: string;
	newPasswordRepeat: string;
	dialogClass: string;
}

interface ILoginProps {
	dark: boolean;
	unauthorized?: boolean;
	forbidden?: boolean;
	header: string;
	text: string;
}

export default class LoginComponent extends React.Component<ILoginProps, ILoginState> {
	private readonly DAYS_IN_YEAR = 365;
	private readonly MILLISECONDS_IN_DAY = 86400000;
	private readonly PASSWORD_MINIMUM_LENGTH = 6;

	private _unauthorizedText = 'Please make sure you are signed in and have access to this project.' +
		'If the problem persists, please email support@insidemaps.com';
	private _unauthorizedHeader = 'Oops, this project is not available';
	private _isMobile = false;

	constructor(props: ILoginProps) {
		super(props);

		this.state = {
			newUserPage: false,
			dialogOpen: false,
			username: '',
			password: '',
			errorMessage: '',
			newEmail: '',
			newPassword: '',
			newPasswordRepeat: '',
			dialogClass: 'dialog-content',
		};

		this.signIn = this.signIn.bind(this);
		this.createNewUser = this.createNewUser.bind(this);
		this.updateUsername = this.updateUsername.bind(this);
		this.updatePassword = this.updatePassword.bind(this);
		this.updateNewEmail = this.updateNewEmail.bind(this);
		this.updateNewPassword = this.updateNewPassword.bind(this);
		this.updateNewPasswordRepeat = this.updateNewPasswordRepeat.bind(this);
		this.toggleNewUserPage = this.toggleNewUserPage.bind(this);
		this.toggleDialog = this.toggleDialog.bind(this);
	}

	public componentDidMount() {
		this.checkDialogStyle();
		window.addEventListener('resize', this.onWindowResize.bind(this));
	}

	public render() {
		const signin = (
			<form
				style={{
					display: 'flex',
					flexDirection: 'column',
				}}
				onSubmit={this.signIn}
			>
				<TextField
					key='username-input'
					type='text'
					className={'input'}
					InputProps={{
						inputProps: {
							className: 'input-props-username',
						},
					}}
					autoComplete='username'
					color='primary'
					onChange={this.updateUsername}
					value={this.state.username}
					placeholder='email or username'
				/>
				{/* <div key='new-user-helper' className={'helper-text-wrapper'}>
					<a className={'helper-text'} onClick={this.toggleNewUserPage}>
						New user?
					</a>
				</div> */}
				<TextField
					key='password-input'
					type='password'
					className={'input'}
					InputProps={{
						inputProps: {
							className: 'input-props-password',
						},
					}}
					autoComplete='current-password'
					color='primary'
					onChange={this.updatePassword}
					value={this.state.password}
					placeholder='password'
				/>
				<Button
					key='sign-in-button'
					type='submit'
					className={'sign-in-button'}
					variant='contained'
				>
					SIGN IN
				</Button>
				<div key='error-message' className={'error-text'}>
					{this.state.errorMessage}
				</div>
			</form>
		);

		const newUser = ([
			<TextField
				key='new-email-input'
				type='email'
				className={'input'}
				InputProps={{
					inputProps: {
						className: 'input-props-new-user',
					},
				}}
				autoComplete='nope'
				color='primary'
				onChange={this.updateNewEmail}
				value={this.state.newEmail}
				placeholder='email'
			/>,
			<div key='already-user-helper' className={'helper-text-wrapper'}>
				<a onClick={this.toggleNewUserPage} className={'helper-text'}>
					Already a user?
				</a>
			</div>,
			<TextField
				key='new-password-input'
				type='password'
				className={'input'}
				autoComplete='new-password'
				color='primary'
				onChange={this.updateNewPassword}
				value={this.state.newPassword}
				placeholder='password'
			/>,
			<TextField
				key='new-password-repeat-input'
				type='password'
				className={'input'}
				autoComplete='new-password'
				color='primary'
				onChange={this.updateNewPasswordRepeat}
				value={this.state.newPasswordRepeat}
				placeholder='repeat password'
			/>,
			<div key='error-massage' className={'error-text'}>
				{this.state.errorMessage}
			</div>,
			<Button
				key='create-account-button'
				className={'sign-in-button'}
				variant='contained'
				onClick={this.createNewUser}
			>
				Create account
			</Button>,
		]);

		const loginDialog = (
			<Dialog fullScreen={this._isMobile} maxWidth='sm' open={this.state.dialogOpen} onClose={this.toggleDialog}>
				<DialogContent className={this.state.dialogClass}>
					<span className='logo' style={{
						backgroundImage: this.props.dark ? 'url(images/logo/logo-white.png)' : 'url(images/logo/logo-black.png)',
					}}></span>
					{this.state.newUserPage ? newUser : signin}
				</DialogContent>
			</Dialog>
		);

		const forbiddenPage = (
			<ErrorMessage errorHeader={this.props.header} errorText={this.props.text} />
		);

		const unauthorizedPage = (
			<div key='unauthorized-page'>
				{<div style={{textAlign: 'center'}}>
					<ErrorMessage
						errorHeader={this.props.header || this._unauthorizedHeader}
						errorText={this.props.text || this._unauthorizedText}
					/>
					<Fab
						className={'login-in-button'}
						onClick={this.toggleDialog}
						variant='extended'
						color='secondary'
					>
						SIGN IN
					</Fab>
				</div>}
			</div>
		);

		return (
			<div>
				{(this.props.unauthorized && unauthorizedPage)}
				{(this.props.forbidden && forbiddenPage)}
				{loginDialog}

			</div>
		);
	}

	private toggleNewUserPage() {
		const newUserState = !this.state.newUserPage;
		this.setState({
			newUserPage: newUserState,
			errorMessage: '',
		});
	}

	private toggleDialog() {
		this.setState({
			dialogOpen: !this.state.dialogOpen,
			errorMessage: '',
			newUserPage: false,
		});
	}

	private signIn(event: React.FormEvent<HTMLFormElement>) {
		event.preventDefault();

		if (this.state.username && this.state.password) {
			Axios.post('/login', {
				username: this.state.username,
				password: this.state.password,
			})
			.then((response) => {
				if (!response.data) {
					throw new Error('Invalid username and password.');
				}
				this.setCookie('IM_SESSION', response.data, this.DAYS_IN_YEAR);
				location.reload();
			})
			.catch((error) => {
				this.responseError(error);
			});
		} else {
			this.responseError({message: 'Please fill all the fields.'});
		}
	}

	private createNewUser() {
		if (!this.state.newPassword || !this.state.newPasswordRepeat || !this.state.newEmail) {
			this.setState({errorMessage: 'Please fill all the fields.'});
			return;
		}
		const emailCheck = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/u;
		if (!emailCheck.test(this.state.newEmail)) {
			this.setState({errorMessage: 'Email address has bad format.'});
			return;
		}

		if (this.state.newPassword === this.state.newPasswordRepeat && !this.state.errorMessage) {
			Axios.post('/signUp', {
				email: this.state.newEmail,
				password: this.state.newPassword,
			})
			.then((response) => {
				if (response.status === -1) {
					throw new Error('Account already exists for this username.');
				}
				this.setCookie('IM_SESSION', response.data, this.DAYS_IN_YEAR);
				location.reload();
			})
			.catch((error) => {
				this.responseError(error);
			});
		}
	}

	private setCookie(cname: string, cvalue: string, exdays: number) {
		const date = new Date();
		date.setTime(date.getTime() + (exdays * this.MILLISECONDS_IN_DAY));

		const expires = `expires=${date.toUTCString()}`;

		document.cookie = `${cname}=${cvalue};${expires};path=/`;
	}

	private responseError(error: any) {
		this.setState({
			errorMessage: error.message,
			username: '',
			password: '',
			newEmail: '',
			newPassword: '',
			newPasswordRepeat: '',
		});
	}

	private updatePassword(event: React.ChangeEvent<HTMLInputElement>) {
		this.setState({
			password: event.target.value,
		});
	}

	private updateUsername(event: React.ChangeEvent<HTMLInputElement>) {
		this.setState({
			username: event.target.value,
		});
	}

	private updateNewEmail(event: React.ChangeEvent<HTMLInputElement>) {
		this.setState({
			newEmail: event.target.value,
		});
	}

	private updateNewPassword(event: React.ChangeEvent<HTMLInputElement>) {
		const messageForShortPassword = event.target.value &&
			event.target.value.length < this.PASSWORD_MINIMUM_LENGTH &&
			this.state.newPasswordRepeat ? 'Password has to be minimum 6 characters long.' : '';

		const messageForNotMatching = event.target.value &&
			this.state.newPasswordRepeat &&
			(event.target.value !== this.state.password) ? 'Passwords do not match.' : '';

		this.setState({
			newPassword: event.target.value,
			errorMessage: messageForNotMatching || messageForShortPassword,
		});
	}

	private updateNewPasswordRepeat(event: React.ChangeEvent<HTMLTextAreaElement>) {
		const messageForShortPassword = event.target.value.length < this.PASSWORD_MINIMUM_LENGTH &&
			event.target.value ? 'Password has to be minimum 6 characters long.' : '';

		const messageForNotMatching = event.target.value &&
			(event.target.value !== this.state.newPassword) ? 'Passwords do not match.' : '';

		this.setState({
			newPasswordRepeat: event.target.value,
			errorMessage: messageForNotMatching || messageForShortPassword,
		});
	}

	private checkDialogStyle() {
		const SCREEN_SIZE_MOBILE_BREAKPOINT = 481;

		if (window.innerHeight > window.innerWidth) {
			this.setState(
				{dialogClass: (window.innerWidth < SCREEN_SIZE_MOBILE_BREAKPOINT) ? 'dialog-content-mobile' : 'dialog-content'},
			);
			this._isMobile = (window.innerWidth < SCREEN_SIZE_MOBILE_BREAKPOINT) || false;
		} else {
			this.setState(
				{dialogClass: (window.innerHeight < SCREEN_SIZE_MOBILE_BREAKPOINT) ? 'dialog-content-mobile' : 'dialog-content'},
			);
			this._isMobile = (window.innerHeight < SCREEN_SIZE_MOBILE_BREAKPOINT) || false;
		}
	}

	private onWindowResize() {
		this.checkDialogStyle();
	}
}
